import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import $ from 'jquery';
import { AuthImpurePipe } from '@pipes/auth.pipe';
import { SecurityContextService } from '@services/security_context.service';

@Component({
  selector: 'header',
  imports: [CommonModule, AuthImpurePipe],
  templateUrl: './header.component.html',
  styleUrl: './header.component.less',
})
export class HeaderComponent {
  // Constants
  user = undefined;

  constructor(private _securityContextService: SecurityContextService) {}

  // Lifecycle Hooks
  ngOnInit(): void {
    this.user = this._securityContextService.authData();
  }

  // Functions
  logout = () => {
    this._securityContextService.logout();
  };

  minimize = () => {
    // JQuery :(
    if (($(window)?.width() || 0) < 769) {
      $('body').toggleClass('show-sidebar');
    } else {
      $('body').toggleClass('hide-sidebar');
    }
  };
}
